import React from "react";

/**
 * Tabela genérica reutilizável pelas abas de Validação Fiscal.
 * columns: [{ key, label, align?, render?: (row) => node }]
 * rows: array de objetos. `footer` opcional renderiza um <tfoot> com célula(s) de total.
 */
export default function DataTable({ title, subtitle, columns, rows, footer, minWidth = 640 }) {
  return (
    <div className="data-table-card">
      {(title || subtitle) && (
        <div className="data-table-head">
          {title && <div className="data-table-title">{title}</div>}
          {subtitle && <div className="data-table-subtitle">{subtitle}</div>}
        </div>
      )}
      <div className="data-table-scroll">
        <table style={{ minWidth }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.id ?? i}>
                {columns.map((col) => (
                  <td key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
          {footer && (
            <tfoot>
              <tr>
                {columns.map((col) => (
                  <td key={col.key} style={col.align ? { textAlign: col.align } : undefined}>
                    {footer[col.key] ?? ""}
                  </td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
